import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { TrashManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/trash")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <TrashManagement />
    </RouteGuard>
  ),
});
